import AsyncStorage from "@react-native-async-storage/async-storage"
import { clientConfigPath } from "../../config/Constant";
import { fetchAllVenuesFailure, fetchAllVenuesRequest, fetchAllVenuesSuccess, fetchMyReservationFailure, fetchMyReservationRequest, fetchMyReservationSuccess } from "../Reducers/tableReservationReducer";


export const get7roomsRestaurantReservationData = (callback, venueLocationId) => {

    return async (dispatch, getState) => {

        const sessionToken = await AsyncStorage.getItem("sessionToken");
        dispatch(fetchAllVenuesRequest());

        try {
            const response = await clientConfigPath.post('/restaurantTableBooking/getAllVenues', {
                header: {
                    sessionToken
                },
                payload: {},
            });

            console.log('RESPONSE FROM ALL VENUE', response);

            if (response?.data?.payload?.data?.results) {
                // Dispatch success action with the fetched data
                let results = response.data.payload.data.results;
                if(venueLocationId){
                    results = results.filter(event => event.id == venueLocationId);
                }
                dispatch(fetchAllVenuesSuccess(results));
                callback(true)
            } else {
                dispatch(fetchAllVenuesFailure(response?.data?.header?.status?.msg || "Something went wrong"));
                callback(false, response?.data?.header?.status?.msg || "Something went wrong")
            }
        } catch (error) {
            const errorMessage =  error.response?.data?.header?.status?.msg || error?.message || "Something went wrong";
            dispatch(fetchAllVenuesFailure(errorMessage));
            callback(false, errorMessage);
        }
    }
}

export const getMyReservationData = (callback=()=>{}) => {
    return async (dispatch, getState) => {

        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const { currentGuestDetails } = getState().guestDetailsSlice;
        const tableReservationClientId = await AsyncStorage.getItem('tableReservationClientId');

        dispatch(fetchMyReservationRequest());

        if(!tableReservationClientId || tableReservationClientId == ""){
            dispatch(fetchMyReservationSuccess([]));
            return
        }

        try {
            const response = await clientConfigPath.post(`/restaurantTableBooking/getAllReservations`, {
                "header": {
                    "sessionToken": sessionToken,
                    "reservationNumber": currentGuestDetails?.reservationNumber,
                    "guestToken": currentGuestDetails?.guestToken,
                },
                "payload": {
                    "clientId": tableReservationClientId
                }
            })
            dispatch(fetchMyReservationSuccess(response.data.payload));
            callback(true);
        } catch (error) {
            const errorMessage =  error.response?.data?.header?.status?.msg || error?.message || "Something went wrong"
            dispatch(fetchMyReservationFailure(errorMessage));
            callback(false, errorMessage);

        }
    }
}

export const cancelRestaurantReservation = (cancelId) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');

        const { currentGuestDetails } = getState().guestDetailsSlice;
        

        try {
            let data = await clientConfigPath.post(`/restaurantTableBooking/cancelReservation`, {
                "header": {
                    "sessionToken": sessionToken,
                    "reservationNumber": currentGuestDetails?.reservationNumber,
                    "guestToken": currentGuestDetails?.guestToken,
                },
                "payload": {
                    "reservationId": cancelId
                }
            })

            return data
        } catch (error) {
            return error
        }
    }
}

export const updateRestaurantReservationV2 = (payload) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const { currentGuestDetails } = getState().guestDetailsSlice;
        

        try {
            const response = await clientConfigPath.post(`/restaurantTableBooking/updateReservation`, {
                "header": {
                    "sessionToken": sessionToken,
                    "reservationNumber": currentGuestDetails?.reservationNumber,
                    "guestToken": currentGuestDetails?.guestToken,
                },
                "payload": payload
            })

            return { status: true }
        } catch (error) {
            const errorMessage =  error.response?.data?.header?.status?.msg || error?.message || "Something went wrong";

            return { status: false, message: errorMessage }
        }
    }
}


export const searchVenueAvailability = (payload) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');

        try {
            const response = await clientConfigPath.post(`/restaurantTableBooking/getVenueAvailability`,{
                "header": {
                    "sessionToken": sessionToken
                },
                "payload": payload
            })
            console.log('DATA FOR VENUE AVAILABILITY -00000', response);
            if(response?.data?.payload?.data?.availability?.length){
                return { status: true, data: response?.data?.payload?.data?.availability }
            }
            return { status: false, data:  response?.data?.header?.status?.msg || "Something went wrong" }
        } catch (error) {
            const errorMessage =  error.response?.data?.header?.status?.msg || error?.message || "Something went wrong";

            return { status: false, data: errorMessage }
        }
    }
}


export const searchDailyProgrammeData = (payload) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const { currentGuestDetails } = getState().guestDetailsSlice;

        try {
            const response = await clientConfigPath.post(`/restaurantTableBooking/getAllPrograms`, {
                "header": {
                    "sessionToken": sessionToken,
                    "reservationNumber": currentGuestDetails?.reservationNumber,
                    "guestToken": currentGuestDetails?.guestToken,
                },
                "payload": payload
            })

            console.log('DATA FOR DAILY ALL PROGRAMS 7777', response);

            if(response?.data?.payload?.data?.length){
                return { status: true, data: response?.data?.payload?.data }
            }
            return { status: false, data:  response?.data?.header?.status?.msg || "Something went wrong" }
        } catch (error) {
            const errorMessage =  error.response?.data?.header?.status?.msg || error?.message || "Something went wrong";

            return { status: false, data: errorMessage }
        }
    }
}


export const createRestaurantReservationV2 = (payload) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        const { currentGuestDetails } = getState().guestDetailsSlice;

        try {
            const response = await clientConfigPath.post(`/restaurantTableBooking/createReservation`, {
                "header": {
                    "sessionToken": sessionToken,
                    "reservationNumber":  currentGuestDetails?.reservationNumber,
                    "guestToken":  currentGuestDetails?.guestToken,
                },
                "payload": payload
            })

            if(response?.data?.header?.status?.responseCode == 409){
                return { status: true, statusCode: 409, data: response?.data?.header?.status?.msg }
            }

            if(!response?.data?.payload?.data?.client_id){
                return { status: false, data: "Client ID not found" }
            }

            return { status: true, data: response?.data?.payload?.data?.client_id }

        } catch (error) {
            const errorMessage =  error.response?.data?.header?.status?.msg || error?.message || "Something went wrong";
            return { status: false, data: errorMessage }
        }
    }
}


